import Vue from "vue";
import "@/app/plugins/vuetify";
// import "vuetify/src/stylus/app.styl";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
// eslint-disable-next-line
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import moment from "moment";
Vue.prototype.moment = moment;

import firebase from "firebase/app";
import "firebase/firestore";

// Vue.use(Vuex)
// Vue.use(vuetify);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    // Initilise firebase
    // Your web app's Firebase configuration
    // For Firebase JS SDK v7.20.0 and later, measurementId is optional

    // PRODUCTION (LIVE DATABASE)
    var config = {
      apiKey: "AIzaSyCF2P6xijHYEyj5t3m1R2HVZDCFpGJ8QRo",
      authDomain: "besefacilities.firebaseapp.com",
      projectId: "besefacilities",
      storageBucket: "besefacilities.appspot.com",
      messagingSenderId: "23641280140",
      appId: "1:23641280140:web:d409f4038eb6f21fb3f5a9",
      measurementId: "G-FECKNSPNC6"
    };

    // PRODUCTION BACK UP (LIVE DATABASE)
    // *******************************************************
    // var config = {
    //   apiKey: "AIzaSyAPksBR-K_yBXk1BB7FeC2lvsP8MYi4UPM",
    //   authDomain: "besealive.firebaseapp.com",
    //   projectId: "besealive",
    //   storageBucket: "besealive.appspot.com",
    //   messagingSenderId: "294036495707",
    //   appId: "1:294036495707:web:b437c71e740cad31a50e7e"
    // };

    firebase.initializeApp(config);

    // Initialize Firebase
    // firebase.initializeApp(firebaseConfig);
    // firebase.analytics();
    // Reference to fire store database
    // eslint-disable-next-line
    // const db = firebase.firestore();
  }
}).$mount("#app");
